import { COPYRIGHT_TEXT, LOGO } from "@/utils/constants/constants";

const AuthBootLoader = () => {
    return (
        <div className="gs-auth-boot-overlay" aria-live="polite" aria-busy="true" style={{zIndex:100000}}>
            <div className="gs-auth-boot-body">
                <div className="gs-auth-boot-form-wrap">
                    <img className="gs-auth-boot-logo" src={LOGO} alt="GreenSign" />
                    <div className="gs-auth-boot-spinner" role="status" aria-label="Loading" />
                </div>
                <div className="gs-auth-boot-footer">
                    <p>{COPYRIGHT_TEXT}</p>
                </div>
            </div>
        </div>
    );
};

export default AuthBootLoader;
